import { Modal, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalFooter } from '~/components/Modal';
import errorHandler from '~/Utils/errorHandler';
import { Table } from '~/components/Table';
import { getFinancialExpenseItems } from '~/services/hooks/financialExpenseItems';
import { viewExpenseColumns } from '~/tables/expenses';

export default function FinancialExpenseItemExpensesView({ visible, onClose, isMobile, financialExItem, year }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const fetchFinancialExpenseItems = async () => {
    setLoading(true);
    try {
      const params = { params: { year: year } };
      const data = await getFinancialExpenseItems(params, `${financialExItem?.id}`);

      setData(data);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (visible && financialExItem) {
      fetchFinancialExpenseItems();
    }
  }, [visible, financialExItem]);

  return (
    <Modal
      title={t('Despesas') + ' - ' + financialExItem?.name + '/' + year}
      onCancel={onClose}
      style={{ maxWidth: isMobile ? '100%' : '700px' }}
      destroyOnClose
      open={visible}
      loading={loading}
      centered
      width="1500px"
      footer={<ModalFooter onOk loading={loading} onCancel={onClose} />}
    >
      <Spin spinning={loading}>
        <Table
          size="middle"
          pagination={false}
          rowKey="id"
          loading={loading}
          dataSource={data?.financial_expense_item_expenses}
          columns={viewExpenseColumns(isMobile)}
          bordered
        />
      </Spin>
    </Modal>
  );
}
